<template>
  <div>
    <div class="animated fadeIn">
      <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"/>
    </div>
    <b-card>
      <template slot="header">
        <b-button class="float-right" variant="success" @click="redirecionar">Adicionar Contato</b-button>
        <strong>
          <h3>Contatos Vinculados</h3>
        </strong>
      </template>
      <b-table
        bordered
        @row-clicked="informacaomodal"
        striped
        hover
        :items="items"
        :fields="fields"
      ></b-table>
      <div>
        <b-modal hide-footer centered ref="informacaocontato">
          <template slot="modal-header">
            <h4>{{tituloselecionado}}</h4>
            <b-button
              class="float-right"
              variant="outline-danger"
              @click="deletarContato()"
            >Apagar Contato</b-button>
          </template>
          <b-form>
            <b-form-group
              id="input-group-1"
              label="Tipo id"
              label-for="input-1"
              v-if="options != null"
            >
              <b-form-select required v-model="tipoidselecionado" :options="options"></b-form-select>
            </b-form-group>
            <b-form-group id="input-group-2" label="Titulo" label-for="input-2">
              <b-form-input
                id="titulo"
                v-model="tituloselecionado"
                type="text"
                required
                placeholder="Titulo"
              ></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-3" label="Descrição" label-for="input-3">
              <b-form-input
                id="descricao"
                v-model="descricaoselecionado"
                type="text"
                required
                placeholder="Descrição"
              ></b-form-input>
            </b-form-group>
          </b-form>
          <b-row>
            <b-col xl="6" md="12" lg="6" sm="12">
              <b-button variant="danger" class="mt-3 botao" @click="closeModal()">Cancelar</b-button>
            </b-col>
            <b-col xl="6" md="12" lg="6" sm="12">
              <b-button variant="success" class="mt-3 botao" @click="save()">Salvar</b-button>
            </b-col>
          </b-row>
        </b-modal>
      </div>
    </b-card>
  </div>
</template>

<script>
import axios from "axios";
import * as config from "@/config.json";
import Loading from "vue-loading-overlay";


export default {
  components: {
    Loading
  },
  data: () => {
    return {
      isLoading: false,
      idselecionado: null,
      tituloselecionado: null,
      tipoidselecionado: null,
      descricaoselecionado: null,
      options: null,
      items: [],
      fields: [
        { key: "tipodescricao", label: "Tipo" },
        { key: "titulo", label: "Titulo" },
        { key: "descricao", label: "Descrição" }
      ]
    };
  },

  async beforeMount() {
    this.isLoading = true;
    await axios
      .get(`${config.default.servidor}/gerencial/retorna-tipos-contato/`, {
        headers: {
          Authorization: "Basic c2E6QURNQUNDRVNZUw=="
        }
      })
      .then(response => {
        if (response.status == 200 && response.data.data.length > 0)
          this.options = response.data.data;
        else this.options = [];
      });

    await this.procurarContatos();
    this.isLoading = false;
  },

  methods: {
    redirecionar() {
      this.$router.push("contatos/inserir-contato");
    },

    informacaomodal(record, index) {
      this.idselecionado = record.id;
      this.tipoidselecionado = record.tipoid;
      this.tituloselecionado = record.titulo;
      this.descricaoselecionado = record.descricao;
      this.$refs.informacaocontato.show();
    },

    closeModal() {
      this.$refs.informacaocontato.hide();
    },

    save() {
      if (this.checarCampos()) {
        axios
          .post(
            `${config.default.servidor}/gerencial/contatos/`,
            {
              id: this.idselecionado,
              tipoid: this.tipoidselecionado,
              titulo: this.tituloselecionado,
              descricao: this.descricaoselecionado
            },
            {
              headers: {
                Authorization: "Basic c2E6QURNQUNDRVNZUw=="
              }
            }
          )
          .then(response => {
            if (response.status == 200 && response.data.error == false) {
              this.items = [];
              this.procurarContatos();
              this.closeModal();
              const options = { title: "Aviso", size: "sm" };
              this.$dialogs.alert("Contato atualizado com sucesso", options);
            }
          })
          .catch(error => {});
      } else {
        const options = { title: "Algo deu errado...", size: "sm" };
        this.$dialogs.alert(
          "Preencha todos os campos antes de continuar.",
          options
        );
      }
    },

    checarCampos() {
      if (this.tipoidselecionado == null) return false;
      if (this.tituloselecionado == null) return false;
      if (this.descricaoselecionado == null) return false;
      return true;
    },

    procurarContatos() {
      axios
        .get(
          `${config.default.servidor}/gerencial/contatos/${localStorage
            .getItem("enterprise_id")
            .toString()}`,
          {
            headers: {
              Authorization: "Basic c2E6QURNQUNDRVNZUw=="
            }
          }
        )
        .then(response => {
          if (response.data.data.length > 0) {
            this.items = response.data.data;
          }
        });
    },

    deletarContato() {
      this.$refs.informacaocontato.hide();
      const options = {
        title: "Aviso",
        cancelLabel: "Cancelar",
        okLabel: "Sim"
      };
      this.$dialogs
        .confirm("Deseja apagar este contato?", options)
        .then(async res => {
          if (res.ok == true) {
            this.isLoading = true;

            await axios
              .delete(
                `${config.default.servidor}/gerencial/contatos/${
                  this.idselecionado
                }`,
                {
                  headers: {
                    Authorization: "Basic c2E6QURNQUNDRVNZUw=="
                  }
                }
              )
              .then(response => {
                if (response.status == 200 && response.data.error == false) {
                  this.items = [];
                  this.procurarContatos();
                }
              })
              .catch(error => {});
              this.isLoading= false;
          }
        });
    }
  }
};
</script>
